import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkedPipe } from './marked.pipe';

@NgModule({
  declarations: [MarkedPipe],
  imports: [CommonModule],
  exports: [MarkedPipe],
})
export class MarkedPipeModule {}
